<template>
  <div class="ec-line018">
    <el-tabs v-model="tab">
      <el-tab-pane :label="$t('ec-line018.tabs.orderHistory')" :name="EC_LINE018.TAB_TYPES.ORDER_HISTORY">
        <order-history-item-list v-for="item in items" :key="item.id" :data="item"> </order-history-item-list>
      </el-tab-pane>
      <el-tab-pane :label="$t('ec-line018.tabs.rePurchase')" :name="EC_LINE018.TAB_TYPES.REPURCHASE"></el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import OrderHistoryItemList from '@/components/ec-line018/OrderHistoryItemList.vue'

import { ORDER_HISTORY } from '@/mocks/ec-line018'

const EC_LINE018 = {
  TAB_TYPES: {
    ORDER_HISTORY: 'order-history',
    REPURCHASE: 'repurchase',
  },
}
export default {
  components: { OrderHistoryItemList },
  data() {
    return {
      tab: EC_LINE018.TAB_TYPES.ORDER_HISTORY,
      items: [],
      EC_LINE018,
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      // TODO implement API
      this.items = ORDER_HISTORY
    },
  },
}
</script>

<style lang="scss">
@import '@/assets/css/pages/ec-line018.scss';
</style>
